import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "@/.sourceflow/candidate_testimonials.json";

export const useTestimonials = ({ filters = null, limit = null } = {}) => {
  let collection = useSourceFlowCollection(data);

  if (filters && filters.length > 0) {
    collection = collection.filter((item) => item?.page.includes(filters));
  }

  if (limit) {
    return collection.slice(0, limit);
  }

  return collection;
};

export default useTestimonials;
